import styled from "styled-components";

interface FormColWrapperProps {
  btnPosition?: string;
}

export const FormColWrapper = styled.div<FormColWrapperProps>`
  flex: 1 1;
  padding: 0 5%;

  ${(props) =>
    props.btnPosition &&
    `
    text-align: ${props.btnPosition}
  `}

  & > label {
    cursor: pointer;

    & > span {
      display: block;
      font-size: 1.2rem;
      margin-bottom: 0.5rem;
      margin-left: 0.2rem;
      color: #fff;
      opacity: 0.5;
    }

    & > input {
      width: 100%;
      height: 4rem;
      outline: none;
      padding: 0 2rem;
      background: #1c1d1e;
      border-radius: 2px;
      border: 1px solid transparent;
      transition: all 0.2s ease-in-out;
      color: #fff;
      opacity: 0.5;

      &:focus {
        border: 1px solid #3fca89;
      }
    }

    & > textarea {
      width: 100%;
      height: 10rem;
      outline: none;
      padding: 1rem 2rem;
      border-radius: 2px;
      background: #1c1d1e;
      border: 1px solid transparent;
      transition: all 0.2s ease-in-out;
      resize: none;
      color: #fff;
      opacity: 0.5;
      font-family: "Catamaran", sans-serif;

      &:focus {
        border: 1px solid #3fca89;
      }
    }
  }

  & button {
    min-width: 14rem;
    max-width: 100%;
    height: 3.8rem;
    border-radius: 2px;
    cursor: pointer;
    border: 1px solid #3fca89;
    background: transparent;
    outline: none;
    color: #3fca89;
    text-transform: uppercase;
    font-size: 1.2rem;

    & > span {
      display: inline-block;
      transform: translateX(1rem);
      transition: all 0.4s ease-in-out;
    }

    & > i {
      opacity: 0;
      transition: all 0.4s ease-in-out;
      margin-left: 1rem;
    }

    &:hover i {
      opacity: 1;
    }

    &:hover span {
      transform: translateX(0);
    }
  }
`;
